import { FC, useState } from "react";
import styles from "./vip.module.css";
import { useGetUserInfoQuery } from "@entities/User/api/UserInformationSlice";
import { EmailVerificationModal } from "../Cash/EmailVerificationModal";
import { useGetSubscriptionsQuery } from "@entities/Shop/api/shopApiSlice";

export const VipShop: FC = () => {
  const { data: userInfo } = useGetUserInfoQuery();
  const [isEmailModalOpen, setIsEmailModalOpen] = useState(false);
  const { data: subscriptions } = useGetSubscriptionsQuery();
  const DISCORD_SHOP_URL = subscriptions?.PaymentLink;

  const handleOpenShop = () => {
    if (userInfo?.email) {
      if (userInfo?.role !== "guest") {
        window.open(DISCORD_SHOP_URL, '_blank');
      }
    }
    else {
      setIsEmailModalOpen(true);
    }
  };

  const handleEmailVerificationSuccess = () => {
    setIsEmailModalOpen(false);
  };

  return (
    <div className={styles.container}>
      <EmailVerificationModal
        isOpen={isEmailModalOpen}
        onClose={() => setIsEmailModalOpen(false)}
        onSuccess={handleEmailVerificationSuccess}
      />
      <div className={styles.vipsContainer}>
        <div className={styles.vipStatusTitle}>
          <p className={styles.vip}>VIP STATUS</p>
          <p className={styles.sub}>SUBSCRIPTION</p>
        </div>
        <div className={styles.vipContent}>
          <ul className={styles.vipList}>
            <li>Доступ к премиум-скинам</li>
            <li>PIN скинов в ротации</li>
            <li>Расширенный список миссий</li>
            <li>До 1000 PYL можно инвестировать в миссии</li>
            <li>До 3000 PYL можно заработать за победу</li>
            <li>Доступ к эксклюзивным кейсам</li>
          </ul>
        </div>
        <div className={styles.vipPurschale}>
          <div>
            <button 
              className={styles.PurshaseButton} 
              onClick={handleOpenShop}
            >
              <span>PURCHASE 3.99$</span>
            </button>
            <p className={styles.PurchaseSub}>Per month</p>
          </div>
        </div>
      </div>
    </div>
  );
};
